import { useEffect, useState } from "react";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { api, resolveImg } from "@/lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="gallery-page">
      <PageHero eyebrow="OUR WORK" title="THE GALLERY" script="a look at the craft" />
      <section className="py-16 bg-paper">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8 columns-2 md:columns-3 lg:columns-4 gap-5 space-y-5">
          {items.map((g, i) => (
            <Reveal key={g.id || i} delay={(i % 4) * 0.05}>
              <div className="break-inside-avoid overflow-hidden group bg-[#e9e6dd] relative" data-testid={`gallery-item-${i}`}>
                <img src={resolveImg(g.img)} alt={g.label} loading="lazy" className="w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-4">
                  <span className="font-display text-gold text-sm tracking-[0.1em]">{g.label.toUpperCase()}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
